export default {"src":"/_next/static/media/reviews-create-request.c78e3ef4.svg","height":42,"width":182,"blurWidth":0,"blurHeight":0};